/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ServiceNowToolsConfigurationName {
    affected_ci = 'affected_ci',
    assigned_to = 'assigned_to',
    caller_id = 'caller_id',
    category = 'category',
    close = 'close',
    cmdb_ci = 'cmdb_ci',
    company = 'company',
    control_effectiveness = 'control_effectiveness',
    correlation_id = 'correlation_id',
    impact_if_realized = 'impact_if_realized',
    occurrence_probability = 'occurrence_probability',
    owning_country = 'owning_country',
    priority = 'priority',
    reason = 'reason',
    short_description = 'short_description',
    state = 'state',
    type = 'type',
    u_cmdb_ci = 'u_cmdb_ci',
    u_comments = 'u_comments',
    u_company = 'u_company',
    u_contact_type = 'u_contact_type',
    u_correlation_id = 'u_correlation_id',
    u_event_class = 'u_event_class',
    u_owner_group = 'u_owner_group',
    u_severity = 'u_severity',
    u_source = 'u_source',
    u_state = 'u_state',
    u_task_caller = 'u_task_caller',
    urgency = 'urgency'
}
